<script lang="ts">
    // Skeleton loader for the Confirmation page
    // Mimics the actual layout: Success icon, title, message, signature card, share buttons
</script>

<div class="max-w-2xl mx-auto px-4 py-8 animate-pulse" data-testid="confirmation-skeleton-loader">
    <div class="flex flex-col items-center text-center">
        <!-- Success Icon Skeleton -->
        <div class="relative mb-6">
            <div class="w-24 h-24 bg-gray-300 rounded-full"></div>
        </div>

        <!-- Title & Message Skeleton -->
        <div class="h-10 w-48 bg-gray-300 rounded mb-2"></div>
        <div class="h-5 w-64 bg-gray-200 rounded mb-6"></div>

        <!-- Signature Progress Card Skeleton -->
        <div class="w-full max-w-md bg-gray-100 border border-gray-200 rounded-xl p-5 mb-8">
            <div class="flex items-center justify-center mb-3">
                <div class="h-6 w-40 bg-gray-300 rounded"></div>
            </div>
        </div>

        <!-- Thank You Message Skeleton -->
        <div class="w-full max-w-md bg-gray-100 border border-gray-200 rounded-xl p-5 mb-8">
            <div class="space-y-2">
                <div class="h-4 bg-gray-300 rounded w-full"></div>
                <div class="h-4 bg-gray-300 rounded w-3/4 mx-auto"></div>
            </div>
        </div>

        <!-- Share Section Skeleton -->
        <div class="w-full max-w-md">
            <div class="h-6 w-32 bg-gray-300 rounded mx-auto mb-4"></div>
            
            <!-- Social Buttons Skeleton -->
            <div class="grid grid-cols-4 gap-3 mb-4">
                <div class="h-20 bg-gray-300 rounded-xl"></div>
                <div class="h-20 bg-gray-300 rounded-xl"></div>
                <div class="h-20 bg-gray-300 rounded-xl"></div>
                <div class="h-20 bg-gray-300 rounded-xl"></div>
            </div>

            <!-- Copy Link Skeleton -->
            <div class="flex items-center gap-2 bg-gray-200 rounded-lg p-2">
                <div class="flex-1 h-10 bg-gray-300 rounded"></div>
                <div class="h-10 w-24 bg-gray-300 rounded-lg"></div>
            </div>
        </div>

        <!-- Navigation Buttons Skeleton -->
        <div class="flex flex-col sm:flex-row gap-3 mt-8 w-full max-w-md">
            <div class="flex-1 h-12 bg-gray-300 rounded-lg"></div>
            <div class="flex-1 h-12 bg-gray-300 rounded-lg"></div>
        </div>
    </div>
</div>

